import { Dispatch, SetStateAction } from "react";
import { DashboardComponentData, DashboardComponentFiltersProp } from "./dashboardComponent.type";

export enum DashboardVisibility {
  CreatorUserOnly = 'creator_user_only',
  SameCompany = 'same_company',
}

export enum DashboardFilters {
  DateRange = 'date_range',
  City = 'city_id_eq',
  EstablishmentBranch = 'establishment_branch_id_eq',
  Equipment = 'equipment_id_eq',
  FuelProductsOnly = 'fuel_products_only',
  EquipmentCategory = 'equipment_category_id_in',
  EquipmentCategoryUnitForConsumption = 'equipment_category_unit_for_consumption_eq',
}

export type DashboardData = {
  components: Omit<DashboardComponentData, 'dashboard_id' | 'data'>[];
  created_at: string;
  creator: {
    id: string;
    full_name: string;
  };
  desired_filters: DashboardFilters[];
  display_name: string;
  id: string;
  updated_at: string;
  visibility: DashboardVisibility;
}

export type DashboardResponse = {
  data: {
    data: DashboardData;
  };
};

export type DashboardFilterProps = {
  filters: DashboardComponentFiltersProp;
  setFilters: Dispatch<SetStateAction<DashboardComponentFiltersProp>>;
}

export type DashboardHiddenFilterProps = {
  value: any;
  onChange: (value: any | undefined) => void;
}
